export default __webpack_public_path__ + "static/media/1t.8d384820.jpg";